module.exports = __webpack_public_path__ + "static/mailgun-e03d80b7c7b07b679daeaf5d84b043d7.png";